import { render, staticRenderFns } from "./componentFile.vue?vue&type=template&id=6e3676ae&scoped=true&"
import script from "./componentFile.vue?vue&type=script&lang=ts&"
export * from "./componentFile.vue?vue&type=script&lang=ts&"
import style0 from "./componentFile.vue?vue&type=style&index=0&id=6e3676ae&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3676ae",
  null
  
)

export default component.exports